<!--
 * @Desc: 
 * @Author: may.li
 * @Date: 2023-05-11 14:11:36
 * @LastEditors: lc
 * @LastEditTime: 2023-06-07 08:14:08
-->
<template>
  <div class="add-danwei">
    <el-form ref="ruleForm"
             :model="viewData"
             :rules="rules"
             label-width="100px">
      <el-form-item label="名称"
                    prop="title">
        <el-input v-model="viewData.title" />
      </el-form-item>
      <el-form-item label="内容">
        <tinymce ref="tinymce"
                 v-model="viewData.content"
                 :height="300" />
      </el-form-item>
    </el-form>
    <div class="fix-fotter">
      <el-button style="min-width: 117px;background: #1067E0;font-size: 16px;"
                 size="mini"
                 type="primary"
                 @click="tijiao('ruleForm')">提交</el-button>
    </div>
  </div>
</template>

<script>
import fetch from "@/api/console/pages";
import Pagination from "@/components/Pagination"; // Secondary package based on el-pagination
import Tinymce from '@/components/Tinymce'
export default {
  data () {
    return {
      showUpload: false,
      // 图片上传组件默认图片
      imageDefaultList: '',
      thumbList: [], // 图片暂存
      list: [],
      viewData: {
        id: "",
        title: '',
        content: '',
      },
      rules: {
        title: [
          {
            required: true,
            message: "请输入名称",
            trigger: "blur",
          },
        ],
      },
    };
  },
  components: {
    Pagination,
    Tinymce
  },
  created () { },
  methods: {
    /**
     * @name: 初始化列表
     * @param {*} obj
     * @return {*}
     * @desc:
     */
    initFun (obj) {
      $(".el-drawer__body").scrollTop(0)
      let that = this
      this.viewData = {
        id: "",
        title: '',
        content: '',
      }


      if (obj.id && obj.type == 1) {
        // 编辑
        this.viewData.id = obj.id;
        fetch.detail({ id: obj.id }).then((res) => {
          console.log(res)
          if (res.code == 200) {
            that.viewData = res.result
            that.viewData.id = res.result.id;

            if (that.viewData.content) {
              that.$nextTick(function () {
                that.$refs.tinymce.setContent(that.viewData.content)
              });
            }
          }
        });
      } else {
        // 新增
      }
    },
    /**
     * @name: 提交
     * @param {*} formName
     * @return {*}
     * @desc: 
     */
    tijiao (formName) {
      let that = this

      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.viewData.id) {
            // 编辑
            fetch.edit(this.viewData).then(res => {
              that.resetForm()
              if (res.code == 200) {
                that.$message.success(res.message);
                that.$emit('onUpdateDrawer', 1)
              } else {
                that.$message.error(res.message);
                that.$emit('onUpdateDrawer', -1)
              }
            })
          } else {
            // 新增
            fetch.create(this.viewData).then(res => {
              that.resetForm()
              if (res.code == 200) {
                that.$message.success(res.message);
                that.$emit('onUpdateDrawer', 1)
              } else {
                that.$message.error(res.message);
                that.$emit('onUpdateDrawer', -1)
              }
            })
          }

        } else {
          // this.$message.warning(this.$t('form.verifyMsg'))
        }
      })
    },
    /**
     * @name: 清空form
     * @return {*}
     * @desc:
     */
    resetForm () {
      this.$refs.tinymce.setContent('')
      this.showUpload = false
      this.imageDefaultList = ''
      this.thumbList = []
      this.$refs["ruleForm"].resetFields();
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
